import { render, staticRenderFns } from "./Locket.vue?vue&type=template&id=4280aa66"
import script from "./Locket.vue?vue&type=script&lang=js"
export * from "./Locket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports